import { CalendarParticipantModel } from '.'
import { isBoolean, isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'
import { WorkflowStatusModel } from '~/model/Workflow'
import { TutorSubjectModel } from '~/model/Tutor'
import type { UnknownObject } from '~/shared/interfaces'

export default class CalendarEvent extends BaseModel {
  id: string = ''
  startTime: string = ''
  endTime: string = ''
  createdAt: string = ''
  isPublic: boolean = false
  status: WorkflowStatusModel | null = null
  extraData: UnknownObject = {}
  attachments: Record<string, Array<TutorSubjectModel>> = {}
  participants: Array<CalendarParticipantModel> = []

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['is_public', 'status', 'extra_data', 'attachments', 'participants'])

      if (isBoolean(data.is_public)) {
        this.isPublic = data.is_public
      }

      if (isUnknownObject(data.status)) {
        this.status = new WorkflowStatusModel(data.status)
      }

      if (isUnknownObject(data.extra_data)) {
        this.extraData = data.extra_data
      }

      if (isUnknownObject(data.attachments)) {
        const attachments = data.attachments
        Object.keys(attachments).forEach(collection => {
          const value = attachments[collection]
          if (Array.isArray(value) && value.length) {
            this.attachments[collection] = value.map(v => new TutorSubjectModel(v))
          }
        })
      }

      if (Array.isArray(data.participants) && data.participants.length) {
        this.participants = data.participants.map(i => new CalendarParticipantModel(i))
      }
    }
  }
}
